export default "__VITE_ASSET__BwzdpgNF__"